import React from 'react';
import { Reveal } from './Reveal';
type Bonus = {
  alt: string;
  image: string;
};
const bonuses: Bonus[] = [{
  alt: 'Bonus 01 — Crystals Decoded: The Complete Reference Guide',
  image: 'https://cdn.magicpatterns.com/uploads/9RY6G9H3QSdyn7Ui1QwShf/ChatGPT_Image_10_ago_2026,_11_09_53_a.m..png'
}, {
  alt: 'Bonus 02 — Sacred Geometry Decoded: The Complete Visual Library',
  image: 'https://cdn.magicpatterns.com/uploads/nBaJ5urhsyQAhe4cfjYGz5/ChatGPT_Image_10_ago_2026,_11_14_18_a.m..png'
}, {
  alt: 'Bonus 03 — The Spiritual Practitioner’s Glossary',
  image: 'https://cdn.magicpatterns.com/uploads/htyEzYDanvqV1qWKEW2BPN/ChatGPT_Image_10_ago_2026,_11_09_35_a.m..png'
}, {
  alt: 'Bonus 04 — The Daily Energy Journal: Printable Wellness & Ritual Logs',
  image: 'https://cdn.magicpatterns.com/uploads/ky8LpQkETUPiK6ML2wcDND/ChatGPT_Image_10_ago_2026,_11_18_56_a.m..png'
}, {
  alt: 'Bonus 05 — Essential Oils Decoded: The Complete Reference Chart',
  image: 'https://cdn.magicpatterns.com/uploads/95JRoPdNGQpZ9pNDsqiDJK/ChatGPT_Image_10_ago_2026,_11_09_16_a.m..png'
}];
export function Bonuses() {
  return <section className="w-full bg-surface px-4 py-20 sm:py-24" data-id="element-19" data-mp="3deacret204ej">
      <div className="mx-auto max-w-6xl" data-id="element-20" data-mp="3r6qhck1lsahk">
        <Reveal className="text-center" data-id="element-21" data-mp="3r5gihsmxey9v">
          <h2 className="font-serif text-4xl leading-tight text-navy sm:text-5xl" data-id="element-22" data-mp="3r8ksj6n2oo8g">
            🎁 5 Exclusive <span className="text-amber" data-id="element-23" data-mp="3n7iu2s0zcg7j">Bonus Resource Kits</span>
          </h2>
          <p className="mt-4 text-sm text-slate sm:text-base" data-id="element-24" data-mp="2zfu61nv6ydwe">
            Included FREE with your purchase
          </p>
        </Reveal>
        <div className="mt-10 flex flex-col items-center gap-5" data-id="element-25" data-mp="38g0id6f5l7tz">
          {bonuses.map((bonus, index) => <Reveal key={bonus.alt} delay={index * 0.04} className="w-full max-w-3xl" data-id="element-26" data-mp="33hffez8ioa1u" data-mpi={index}>
              <figure className="overflow-hidden rounded-2xl border border-amber/50 bg-mist shadow-premium" data-id="element-27" data-mp="nq1bz1drb6th">
                <img src={bonus.image} alt={bonus.alt} className="block h-auto w-full" data-id="element-28" data-mp="ir6tk0jpbk9w" />
              </figure>
            </Reveal>)}
        </div>
      </div>
    </section>;
}